export const TOKEN_NAME = 'buzzToken';
